<template>
<div>
  <page-header :title="title"></page-header>
  <form @submit.prevent="gravar">
    <div class="modal-body">
      <div class="form-horizontal">
        <vue-element-loading :active="isActive" spinner="bar-fade-scale" color="#428BCA"></vue-element-loading>
        <input-form-text textInput="E-mail" :required="true" v-model="form.email" :value="form.email"></input-form-text>
        <input-form-text textInput="Nome" :required="true" v-model="form.name" :value="form.name"></input-form-text>
        <input-form-text type="password" textInput="Senha" :required="true" v-model="form.password" :value="form.password"></input-form-text>
      </div>
    </div>
    <footer-button :disabled="isActive"></footer-button>
  </form>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import VueElementLoading from 'vue-element-loading'
import PageHeader from '@/components/PageHeader'
import InputFormText from '@/components/form/InputForm'
import FooterButton from '@/components/form/FooterButton'
import req from '@/components/request'
import { sucesso, erro } from '@/components/Message'

export default {
	components: {
		VueElementLoading,
		PageHeader,
		InputFormText,
		FooterButton
	},
	computed: {
		...mapGetters([
			'user'
		])
	},
	data() {
		return {
			title: 'Minha Conta',
			form: {
				id: '',
				email: '',
				name: '',
				password: ''
			},
			isActive: false
		}
	},
	methods: {
		gravar() {
			const body = this.form
			req('/minha-conta', 'post', body).then(() => {
				sucesso('Atualizado...')
			}).catch(() => {
				erro()
			})
		}
	},
	created() {
		this.isActive = true
		new Promise((resolve) => {
			this.form.id = this.user.id
			this.form.email = this.user.email
			this.form.name = this.user.name
			resolve()
		}).then(() => {
			this.isActive = false
		})
	}
}
</script>

<style lang="stylus" scoped>

</style>
